import { useEffect, useState } from "react";
import TopSection from "../../LT/TopSection";
import Cards from "../../../components/common/card/Card";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import './KPIMetricReport.css';
import { getPowerBIActionDashboardData } from "../../../redux/actions/PowerBIActionDashboardSlice";
import { Loader } from "../../../components/common/Loader";

const KPIMetricReports = () => {
    const dispatch = useDispatch();

    const [activeItem, setActiveItem] = useState(
        localStorage.getItem("KPIreportsActiveItem") || "Supplier Forecast Confirmation SLA Tracker"
    );

    const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
    const stateSelector = useSelector((state) => state.PowerBIActionDashboardSlice);
    const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
    const [powerBIReportID, setPowerBIReportID] = useState("");

    const reportsConfig = {
        "Supplier Forecast Confirmation SLA Tracker": {
            groupId: process.env.REACT_APP_PBI_SUPPLIER_FORECAST_CONFIRM_SLATRACKER_GROUPID,
            reportId: process.env.REACT_APP_PBI_SUPPLIER_FORECAST_CONFIRM_SLATRACKER_REPORTID
        },
        "Supplier Adoption Metrics": {
            groupId: process.env.REACT_APP_PBI_SUPPLIER_ADOPTION_METRICS_GROUPID,
            reportId: process.env.REACT_APP_PBI_SUPPLIER_ADOPTION_METRICS_REPORTID,
        },
    };

    const cardData = [
        { title: "Supplier Forecast Confirmation SLA Tracker" },
        { title: "Supplier Adoption Metrics" },
    ];

    const callBackFunction = (index, title) => {
        setActiveItem(title);
        localStorage.setItem("KPIreportsActiveItem", title);
    };

    useEffect(() => {
        const getPowerBIReportDetails = async () => {
            try {
                const selectedReport = reportsConfig[activeItem];

                const response = await dispatch(
                    getPowerBIActionDashboardData({
                        dynamicEndpoint: `api/powerBI/embedDetails/group/${selectedReport.groupId}/report/${selectedReport.reportId}`,
                    })
                );

                if (response?.meta?.requestStatus === "fulfilled") {
                    setPowerBIEmbedURL(response?.payload?.embedUrl);
                    setPowerBIReportID(response?.payload?.reportId);
                    setPowerBIAccessToken(response?.payload?.accessToken);
                } else {
                    toast.error(response?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error("API error:", error);

                toast.error("Failed to load report", {
                    autoClose: 2000,
                });
            }
        };

        getPowerBIReportDetails();
    }, [activeItem]);

    const embedConfig = {
        type: "report",
        id: powerBIReportID,
        embedUrl: powerBIEmbedURL,
        accessToken: powerBIAccessToken,
        tokenType: models.TokenType.Embed,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
            },
            navContentPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
            },
        },
    };

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "KPI Metrics" },
                ]}
                tabTitle="KPI Metrics"
            />

            <div className="container">
                <Cards
                    cards={cardData}
                    showBorder={true}
                    callBackFunction={callBackFunction}
                />
            </div>
            {stateSelector?.loading ? <Loader /> :
                <div className="powerBi_cls" style={{ marginTop: 10 }}>
                    {embedConfig?.embedUrl &&
                        embedConfig?.accessToken && (
                            <PowerBIEmbed embedConfig={embedConfig} />
                        )}
                </div>}
        </div>
    );
};

export default KPIMetricReports;